<template>

  <t-page>

    <t-dialog-import type="type-environment"
                     @onImported="onDialogImported"
                     @onDuplicate="openDialogDuplicate"
                     :new-to="currentPage.name + '-form-new'" />

    <t-dialog-duplicate dialog-id="modal-duplicate-type-environment" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError" v-model="formDuplicate"
                        :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">

        <t-input v-model="formDuplicate.typeEnvironmentId"
                 :options="typeEnvironmentOptions"
                 :status="status"
                 label="Modelo de Ambiente" select required />

        <t-input label="Nome do novo modelo de ambiente" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>

    </t-dialog-duplicate>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  @click="openDialogForm('modal-import-type-environment')"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="typeEnvironmentNumber" link-primary-column="name">

        <template #append-actions="{item}">

          <b-button @click="openDialogDuplicate(item.typeEnvironmentId,item.name)"
                    class="opacity-6-hover"
                    v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                    title="Duplicar Modelo de Ambiente">

            <b-icon-files variant="primary"/>

          </b-button>

        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";
import TDialogImport from "@/components/template/dialog/t-dialog-import";
import typeEnvironmentService from "@/services/modules/place/TypeEnvironment.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogDuplicate,TDialogImport},
  name: 'TypeEnvironment',
  data() {
    return {
      enableGeneralFields: false,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeEnvironmentOptions: [],
      formDuplicateShow: false,
      formDuplicate: {
        typeEnvironmentId: 0,
        origin: "",
        changeName: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'place-setting'}},
      ]

    },
    async mountedContinued() {

      await typeEnvironmentService.selectList().then((list) => {
        this.typeEnvironmentOptions = list
      }).catch(error => this.responseError(error))


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogDuplicate(typeEnvironmentId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.typeEnvironmentId = typeEnvironmentId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate-type-environment')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""
      ui.toast(this, "Duplicado", "Novo modelo de ambiente <b>" + item.name + "</b> duplicado com sucesso!", "success", "b-toaster-top-center", true)

      this.getPage(this.pageNumber)
    },

    onDialogImported(){

      this.$bvModal.hide('modal-import-type-environment')
      this.$bvModal.hide('modal-import-models')

      ui.toast(this,'Sucesso','Importação realizada com sucesso!');
      this.getPage(this.pageNumber)
    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

